/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAIcon32Regular = forwardRef('UiCursorAIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.005 6.19c.003-2.472 2.827-3.88 4.802-2.394l15.763 11.85c2.304 1.732 1.077 5.4-1.806 5.397l-7.86-.009a1 1 0 0 0-.8.4l-4.724 6.282c-1.732 2.304-5.4 1.077-5.398-1.806l.023-19.72Zm3.6-.796a1 1 0 0 0-1.6.799l-.023 19.72c0 .96 1.222 1.37 1.8.601l4.723-6.282a3 3 0 0 1 2.401-1.198l7.86.01c.96 0 1.37-1.223.602-1.8L10.606 5.394Z" })));
});
